<template>
  <svg
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.34375 16.3125C10.9316 16.3125 12.2188 15.0253 12.2188 13.4375C12.2188 .8497 1110.9316 10.5625 9.34375 10.5625C7.75593 10.5625 6.46875 11.8497 6.46875 13.4375C6.46875 15.0253 7.75593 16.3125 9.34375 16.3125Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      opacity="0.2"
      d="M6.46875 13.4375C6.46875 12.8689 6.63737 12.313 6.95328 11.8402C7.26918 11.3674 7.7182 10.9989 8.24353 10.7813C8.76887 10.5637 9.34694 10.5068 9.90463 10.6177C10.4623 10.7287 10.9746 11.0025 11.3767 11.4046C11.7788 11.8066 12.0526 12.3189 12.1635 12.8766C12.2744 13.4343 12.2175 14.0124 11.9999 14.5377C11.7823 15.0631 11.4138 15.5121 10.941 15.828C10.4682 16.1439 9.91237 16.3125 9.34375 16.3125H17.25V7.6875H5.75V13.4375H6.46875Z"
      fill="white"
    />
    <path
      d="M4.79673 19.1874C5.20507 18.3271 5.84907 17.6004 6.65393 17.0915C7.4588 16.5826 8.39151 16.3125 9.34375 16.3125C10.296 16.3125 11.2287 16.5826 12.0336 17.0915C12.8384 17.6004 13.4824 18.3271 13.8908 19.1874L19.4062 19.1875C19.5006 19.1875 19.5941 19.1689 19.6813 19.1328C19.7685 19.0967 19.8477 19.0437 19.9145 18.977C19.9812 18.9102 20.0342 18.831 20.0703 18.7438C20.1064 18.6566 20.125 18.5631 20.125 18.4688V5.53125C20.125 5.34063 20.0493 5.15781 19.9145 5.02302C19.7797 4.88823 19.5969 4.8125 19.4062 4.8125H3.59375C3.40313 4.8125 3.22031 4.88823 3.08552 5.02302C2.95073 5.15781 2.875 5.34063 2.875 5.53125V18.4688C2.875 18.5632 2.89359 18.6567 2.92971 18.7439C2.96583 18.8311 3.01878 18.9103 3.08552 18.977C3.15226 19.0438 3.2315 19.0967 3.3187 19.1328C3.4059 19.1689 3.49937 19.1875 3.59375 19.1875L4.79673 19.1874Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.8125 16.3125H17.25V7.6875H5.75V9.125"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  name: "TutorLoginIcon",
  props: {
    color: {
      type: String,
      default: "#FF448F",
    },
  },
}
</script>
